<template>
  <div
    class="temp-img preload-wrap pdf-preview-wrapper"
    :class="{ loaded: imageIsLoaded }"
  >   
    <div
      v-if="loading"
      class="spinner-border-container"
    >
      <div
        class="spinner-border text-secondary"
        role="status"
      >
        <span class="sr-only">Uploading...</span>
      </div>
    </div>
    <div v-if="error">
      {{ error }}
    </div>
    <div
      v-else-if="imageIsLoaded"
      :style="photoStyles"
      class="photo-preview__blur-container pdf-preview__blur"
      :class="{ 'no-blur': !loading }"
    >
      <div class="pdf-name-preview-wrapper"> 
        <a :href="pdfUrl" target="_blank">...{{typeof pdfUrl === 'string' && pdfUrl.substr(pdfUrl.length - 12)}}</a></div>
      </div>
    </div>
</template>

<script>
// import pdfjs from 'pdfjs-dist'

export default {
  name: 'VPdfPreview',
  props: {
    pdfUrl: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dataUrl: '',
    error: '',
    imageIsLoaded: false
  }),
  computed: {
    photoStyles() {
      return `background-image: url(images/pdf.webp);`
    }
  },
  async created() {
    if (!this.pdfUrl) {
      this.dataUrl = this.pdfUrl
      this.imageIsLoaded = true
    } else {
      try {
        // this.dataUrl = await readAsDataURL(this.image)
      } catch (error) {
        this.error = 'Error'
      } finally {
        this.imageIsLoaded = true
      }
    }
  },
  // created(){
  //   console.log("loading",this.loading)
  // }
}
</script>
<style>
.spinner-border-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}

.photo-preview__blur-container.pdf-preview__blur {
  z-index: 2;
  filter: blur(3px);
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.photo-preview__blur-container.no-blur {
  filter: unset;
}
.upload-picks li .temp-img.pdf-preview-wrapper{
  background: transparent;
  position: relative;
}
.pdf-image{
  height: 90px;
}
.pdf-preview-wrapper{
  text-align: center;
  position: absolute;
}
.pdf-name-preview-wrapper{
  bottom: -20px;
  position: absolute;
}
</style>
